import { createUseStyles } from "react-jss";

export const useStyles = createUseStyles({
  root: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 9999,
    background: "#000",
    overflow: "hidden",
    transition: "opacity 50ms ease-out",
  },

  splash: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
});
